import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import trCommon       from './locales/tr/common.json';
import trNav          from './locales/tr/nav.json';
import trAuth         from './locales/tr/auth.json';
import trPublic       from './locales/tr/public.json';
import trHome         from './locales/tr/home.json';
import trAppointments from './locales/tr/appointments.json';
import trCustomers    from './locales/tr/customers.json';
import trServices     from './locales/tr/services.json';
import trSettings     from './locales/tr/settings.json';

import enCommon       from './locales/en/common.json';
import enNav          from './locales/en/nav.json';
import enAuth         from './locales/en/auth.json';
import enPublic       from './locales/en/public.json';
import enHome         from './locales/en/home.json';
import enAppointments from './locales/en/appointments.json';
import enCustomers    from './locales/en/customers.json';
import enServices     from './locales/en/services.json';
import enSettings     from './locales/en/settings.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: {
        common:       trCommon,
        nav:          trNav,
        auth:         trAuth,
        public:       trPublic,
        home:         trHome,
        appointments: trAppointments,
        customers:    trCustomers,
        services:     trServices,
        settings:     trSettings,
      },
      en: {
        common:       enCommon,
        nav:          enNav,
        auth:         enAuth,
        public:       enPublic,
        home:         enHome,
        appointments: enAppointments,
        customers:    enCustomers,
        services:     enServices,
        settings:     enSettings,
      },
    },
    supportedLngs: ['tr', 'en'],
    fallbackLng: 'tr',
    defaultNS: 'common',
    ns: ['common', 'nav', 'auth', 'public', 'home', 'appointments', 'customers', 'services', 'settings'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
